module.exports = __webpack_public_path__ + "static/media/arrow-down.db8ea3de.svg";